import { Section } from "../DesignSystem";
import styles from "./Foundations.module.css";

type Swatch = { name: string; token: string };

const INDIGO: Swatch[] = [
  { name: "Indigo 50", token: "--indigo-50" },
  { name: "Indigo 200", token: "--indigo-200" },
  { name: "Indigo 400", token: "--indigo-400" },
  { name: "Indigo 500", token: "--indigo-500" },
  { name: "Indigo 600", token: "--indigo-600" },
];

const AMBER: Swatch[] = [
  { name: "Amber 50", token: "--amber-50" },
  { name: "Amber 300", token: "--amber-300" },
  { name: "Amber 500", token: "--amber-500" },
];

const NEUTRALS: Swatch[] = [
  { name: "White", token: "--white" },
  { name: "Ground", token: "--ground" },
  { name: "Border", token: "--border" },
  { name: "Muted", token: "--muted" },
  { name: "Body", token: "--body" },
  { name: "Ink", token: "--ink" },
];

const SwatchCard = ({ swatch }: { swatch: Swatch }) => (
  <div className={styles.swatch}>
    <div className={styles.swatchColor} style={{ background: `var(${swatch.token})` }} />
    <div className={styles.swatchMeta}>
      <div className={styles.swatchName}>{swatch.name}</div>
      <div className={styles.swatchValue}>{swatch.token}</div>
    </div>
  </div>
);

const SPACING = [
  { token: "--space-1", px: 4 },
  { token: "--space-2", px: 8 },
  { token: "--space-3", px: 12 },
  { token: "--space-4", px: 16 },
  { token: "--space-5", px: 20 },
  { token: "--space-6", px: 24 },
  { token: "--space-8", px: 32 },
  { token: "--space-10", px: 40 },
  { token: "--space-12", px: 48 },
  { token: "--space-16", px: 64 },
];

export const Foundations = () => (
  <>
    <Section label="01 · Foundations" title="Palette">
      <div className={styles.paletteGrid}>
        {INDIGO.map((s) => (
          <SwatchCard key={s.token} swatch={s} />
        ))}
      </div>
      <div className={styles.paletteGrid}>
        {AMBER.map((s) => (
          <SwatchCard key={s.token} swatch={s} />
        ))}
      </div>
      <div className={styles.paletteGrid}>
        {NEUTRALS.map((s) => (
          <SwatchCard key={s.token} swatch={s} />
        ))}
      </div>
    </Section>

    <Section label="02 · Foundations" title="Type">
      <div className={styles.typeRow}>
        <div className={styles.typeLabel}>Display</div>
        <div className={styles.display}>Through Word &amp; Sound</div>
      </div>
      <div className={styles.typeRow}>
        <div className={styles.typeLabel}>H1</div>
        <div className={styles.h1}>Good morning, Faria.</div>
      </div>
      <div className={styles.typeRow}>
        <div className={styles.typeLabel}>H2</div>
        <div className={styles.h2}>Where does the recorder live?</div>
      </div>
      <div className={styles.typeRow}>
        <div className={styles.typeLabel}>H3</div>
        <div className={styles.h3}>Stored encrypted. Nobody at Shobdo sees these.</div>
      </div>
      <div className={styles.typeRow}>
        <div className={styles.typeLabel}>Body</div>
        <div className={styles.body}>
          Shobdo is a Bengali word meaning both "word" and "sound" — the most natural ways humans
          connect and make sense of the world.
        </div>
      </div>
      <div className={styles.typeRow}>
        <div className={styles.typeLabel}>Small</div>
        <div className={styles.small}>Used by agents to reason about what normal looks like.</div>
      </div>
      <div className={styles.typeRow}>
        <div className={styles.typeLabel}>Kicker</div>
        <div className={styles.kicker}>Store owner dashboard</div>
      </div>
    </Section>

    <Section label="03 · Foundations" title="Spacing">
      <div className={styles.spacingScale}>
        {SPACING.map((s) => (
          <div key={s.token} className={styles.spacingRow}>
            <span>{s.token}</span>
            <span>{s.px}px</span>
            <div className={styles.spacingBar} style={{ width: `var(${s.token})` }} />
          </div>
        ))}
      </div>
    </Section>
  </>
);
